import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    CircularProgress
} from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: "2%",
        margin: "2%"
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default

        }
    },
    formControl: {
        width: "100%"
    },
    buttons: {
        textAlign: "right"
    },
    screen: {
        display: "flex",
    },
});

const PCProductEditForm = props => {
    const { classes, formSettings, editable, initialValues, handleSubmit, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(true);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <TextField
                                name="RAM"
                                value={values.RAM}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.RAM && touched.RAM)}
                                placeholder={translations['ram'] || 'RAM'}
                                label={translations['ram'] || 'RAM'}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="Version"
                                value={values.Version}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Version && touched.Version)}
                                placeholder={translations['version'] || 'Version'}
                                label={translations['version'] || 'Version'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Webcam"
                                value={values.Webcam}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Webcam && touched.Webcam)}
                                placeholder={translations['webcam'] || 'Webcam'}
                                label={translations['webcam'] || 'Webcam'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="WebcamVendor"
                                value={values.WebcamVendor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.WebcamVendor && touched.WebcamVendor)}
                                placeholder={translations['webcam_vendor'] || 'Webcam vendor'}
                                label={translations['webcam_vendor'] || 'Webcam vendor'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Bluetooth"
                                value={values.Bluetooth}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Bluetooth && touched.Bluetooth)}
                                placeholder={translations['bluetooth'] || 'Bluetooth'}
                                label={translations['bluetooth'] || 'Bluetooth'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="BluetoothVendor"
                                value={values.BluetoothVendor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.BluetoothVendor && touched.BluetoothVendor)}
                                placeholder={translations['bluetooth_vendor'] || 'Bluetooth vendor'}
                                label={translations['bluetooth_vendor'] || 'Bluetooth vendor'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div className={classes.screen}>
                                <TextField
                                    name="Resolution"
                                    value={values.Resolution}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Resolution && touched.Resolution)}
                                    placeholder={translations['resolution'] || 'Resolution'}
                                    label={translations['resolution'] || 'Resolution'}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <TextField
                                    name="ScreenSize"
                                    value={values.ScreenSize}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.ScreenSize && touched.ScreenSize)}
                                    placeholder={translations['screen_size'] || 'Screen size'}
                                    label={translations['screen_size'] || 'Screen size'}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                            </div>
                            <TextField
                                name="OperatingSystem"
                                value={values.OperatingSystem}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.OperatingSystem && touched.OperatingSystem)}
                                placeholder={translations['operating_system'] || 'Operating system'}
                                label={translations['operating_system'] || 'Operating system'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="NetworkStandard"
                                value={values.NetworkStandard}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.NetworkStandard && touched.NetworkStandard)}
                                placeholder={translations['network_standard'] || 'Network standard'}
                                label={translations['network_standard'] || 'Network standard'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="UUID"
                                value={values.UUID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.UUID && touched.UUID)}
                                placeholder={translations['uuid'] || 'UUID'}
                                label={translations['uuid'] || 'UUID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SecurazeVersion"
                                value={values.SecurazeVersion}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SecurazeVersion && touched.SecurazeVersion)}
                                placeholder={translations['securaze_version'] || 'Securaze version'}
                                label={translations['securaze_version'] || 'Securaze version'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled
                            />
                            <TextField
                                name="HardwareID"
                                value={values.HardwareID}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.HardwareID && touched.HardwareID)}
                                placeholder={translations['hardware_id'] || 'HardwareID'}
                                label={translations['hardware_id'] || 'HardwareID'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ANumber"
                                value={values.ANumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ANumber && touched.ANumber)}
                                placeholder={translations['anumber'] || 'ANumber'}
                                label={translations['anumber'] || 'ANumber'}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    style={{ width: '100%' }}
                                    type="submit"
                                    disabled={!(isValid && dirty) || isSubmitting || !editable}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(PCProductEditForm);
